import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environment';
import { Account } from '@models/account';
import { AccountService } from '@services/account.service';
import { LanguageSyncService } from '@services/language-sync.service';
import { UserService } from '@services/user.service';
import { BaseComponent } from 'src/app/base/base/base.component';

@Component({
    selector: 'cp-customer-account-selector',
    templateUrl: './customer-account-selector.component.html',
    styleUrls: ['./customer-account-selector.component.less'],
    standalone: false
})
export class CustomerAccountSelectorComponent extends BaseComponent implements OnInit
{
    protected _localImageLocation: string = environment.LocalImageLocation;

    busy: boolean = false;

    get showAccounts(): boolean {
        return true;
    }

    accounts: Account[] = [];

    searchHelpText: string;
    searchButtonTitle: string;

    toolTip: string;

    searchCriteria: string = '';
    pagedAccounts: Account[][];
    currentPage: number = 0;
    maxPages: number = 0;
    noResultsFound: boolean = false;

    constructor(
        private _userService: UserService,
        private _router: Router,
        private _languageSyncService: LanguageSyncService
    ) {
        super();

        this.subscriptions.push(_languageSyncService.getLanguage().subscribe({ next: () => this.ngOnInit() }));
    }

    ngOnInit() {
        this.searchAccounts();
    }

    searchAccounts(): void {
        this.busy = true;
        this.noResultsFound = false;
        this._userService
            .getAccountsForUser(this.searchCriteria, this._userService.getCurrentUser().UserId)
            .subscribe({
                next: (accounts: Account[]) => {
                    this.busy = false;
                    this.accounts = accounts;

                    if (accounts && accounts.length > 0 ) {
                        if (accounts.length === 1 && this.searchCriteria === '') {
                            this.pagedAccounts = [];
                            this.accountSelected(accounts[0]);
                        } else {
                            let startIdx: number = 0;
                            let page: number = 0;
                            this.pagedAccounts = [];
                            do {
                                this.pagedAccounts[page] = accounts.slice(startIdx, startIdx + 20);
                                startIdx += 20;
                                page++;
                            } while (startIdx < accounts.length);
                            this.maxPages = page;
                            this.currentPage = 0;
                        }
                    } else {
                        this.pagedAccounts = [];
                        this.maxPages = 0;
                        this.noResultsFound = true;
                    }
                },
                error: (error: any) => {
                    this.busy = false;
                    this.handleError(error);
                }
            });
    }

    accountSelected(account: Account): void {
        let currentAccount: Account = this._userService.getCustomerAccount();
        if ((currentAccount?.AccountNumber !== account.AccountNumber)) {
            this._userService.setCustomerAccount(account);
        }
        this._router.navigate(['home']);
    }

    setPage(page: number): void {
        this.currentPage = page;
    }

    incrementPage(increment: number): void {
        this.currentPage += increment;
        if (this.currentPage > this.maxPages - 1) {
            this.currentPage = this.maxPages - 1;
        } else if (this.currentPage < 0) {
            this.currentPage = 0;
        }
    }
}
